import { useEffect, useState } from "react";
import EntityEditor from "../components/EntityEditor";
import { adminApi } from "../api";

const FIELDS = [
  { key: "title", label: "Titolo documento", required: true },
  {
    key: "category",
    label: "Categoria",
    type: "select",
    options: [
      { value: "Financial", label: "Financial" },
      { value: "Strategy", label: "Strategy" },
      { value: "Project", label: "Project" },
      { value: "Sustainability", label: "Sustainability" },
      { value: "BDO", label: "BDO" },
      { value: "Legal", label: "Legal" },
      { value: "Other", label: "Altro" },
    ],
  },
  { key: "period", label: "Periodo", placeholder: "Es. Q4 2025, Bilancio 2024" },
  {
    key: "file_url",
    label: "File PDF (max 4 MB)",
    type: "pdf",
    autoFillSize: "size",
  },
  { key: "size", label: "Dimensione (auto-compilata dall'upload)", placeholder: "3.2 MB" },
  { key: "updated", label: "Ultimo aggiornamento", type: "date", required: true },
];

const INITIAL = {
  title: "",
  category: "Financial",
  period: "",
  size: "",
  updated: new Date().toISOString().slice(0, 10),
  file_url: "",
  file_size_bytes: 0,
};

export default function AdminDocuments() {
  const [items, setItems] = useState([]);
  const load = () =>
    adminApi.get("/admin/investor-documents").then((r) => setItems(r.data));
  useEffect(() => {
    load();
  }, []);

  return (
    <EntityEditor
      title="Documenti Investitori"
      subtitle="Documenti visibili nell'area riservata investitori. Carica PDF (max 4 MB) — bilanci, BDO, strategy, sostenibilità."
      endpoint="/admin/investor-documents"
      fields={FIELDS}
      items={items}
      initial={INITIAL}
      onReload={load}
      imageField={null}
      renderRow={(item) => (
        <div>
          <div className="font-display text-lg flex items-center gap-2 flex-wrap">
            {item.title}
            {item.file_url ? (
              <span className="text-[9px] uppercase tracking-[0.2em] font-mono px-2 py-0.5 rounded-full bg-emerald-400/10 text-emerald-400">
                PDF
              </span>
            ) : (
              <span className="text-[9px] uppercase tracking-[0.2em] font-mono px-2 py-0.5 rounded-full bg-amber-400/10 text-amber-400">
                Nessun file
              </span>
            )}
            {item.download_count > 0 && (
              <span
                className="text-[9px] uppercase tracking-[0.2em] font-mono px-2 py-0.5 rounded-full bg-[#C48F56]/15 text-[#C48F56]"
                title={
                  item.last_downloaded_at
                    ? `Ultimo download: ${new Date(item.last_downloaded_at).toLocaleString("it-IT")}`
                    : ""
                }
              >
                {item.download_count} download
              </span>
            )}
          </div>
          <div className="mt-1 text-xs text-white/50 font-mono uppercase tracking-[0.15em]">
            {item.category} · {item.period || "—"} · {item.size || "—"} · agg.{" "}
            {item.updated}
          </div>
        </div>
      )}
    />
  );
}
